import React from 'react'
import { faStar as faStarSolid } from '@fortawesome/free-solid-svg-icons'  
import { faStar as faStarRegular } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useUpdateCompetencyEvaluationMutation } from '../../redux/growth-wheel.endpoints'

interface CompetencyAssessmentTitleCardProps {
  name: string
  description: string
  isFocus?: boolean
  evaluationId?: number
}

const CompetencyAssessmentTitleCard = ({
  name,
  description,
  isFocus,
  evaluationId,
}: CompetencyAssessmentTitleCardProps) => {
  const [updateCompetencyEvaluation] =
    useUpdateCompetencyEvaluationMutation()

  const handleToggleFocusClick = async () => {
    if (evaluationId == null) return
    const newFocus = !(isFocus ?? false)
    await updateCompetencyEvaluation({
      evaluationId,
      payload: { focus: newFocus },
    }).unwrap()
  }

  return (
    <div className="card gw-competency-assessment-title-card">
      <div className="card-body gw-competency-area-view-body">
        <div className="d-flex align-items-center gap-2 ">
        <h3 className="gw-competency-area-view-title">
            {name}
          </h3>
        <span
            onClick={evaluationId != null ? handleToggleFocusClick : undefined}
            role="button"
            aria-disabled={evaluationId == null}
            className={`p-1 rounded gw-competency-focus-button ${
              evaluationId == null ? 'opacity-50' : ''
            } ${isFocus ? 'text-warning' : 'text-secondary'}`}
            title={
              evaluationId == null
                ? 'Cannot update focus'
                : isFocus
                  ? 'Remove from areas of focus'
                  : 'Mark as area of focus'
            }
          >
            <FontAwesomeIcon
              icon={isFocus ? faStarSolid : faStarRegular}
              style={{ fontSize: '1.3rem' }}
            />
          </span>
        </div>
        <p className="gw-competency-area-view-description">{description}</p>
      </div>
    </div>
  )
}

export default React.memo(CompetencyAssessmentTitleCard)
